export const mainPaths = {
  login: '/login',
  software: '/software',
  materialDb: '/material-db',
  timesheets: '/timesheets',
  raci: '/raci',
  mcs: '/mcs/:projectId',
  mrqs: '/all-mrqs',
};
